export default __webpack_public_path__ + "browserconfig.xml";